module.exports = __webpack_public_path__ + "static/media/4ditton_edited.a97854e5.jpg";